import React from 'react'
import PropTypes from 'prop-types'
import NavButton from '../NavButton'
import { ButtonWrapper, ButtonTitle } from './style'

const PageNavButton = ({
  title,
  onClickFunc,
  content,
  ariaLabel,
  isDisabled,
  isStopAccessBtn,
  isInPageBody,
  isFocused,
}) => {
  return (
    <ButtonWrapper haveTitle={title ? true : false} isInPageBody={isInPageBody}>
      {title && <ButtonTitle>{title}</ButtonTitle>}
      <NavButton
        onClickFunc={onClickFunc}
        content={content}
        ariaLabel={ariaLabel}
        isDisabled={isDisabled}
        isStopAccessBtn={isStopAccessBtn}
        isFocused={isFocused}
      />
    </ButtonWrapper>
  )
}

NavButton.propTypes = {
  title: PropTypes.string,
  onClickFunc: PropTypes.func,
  content: PropTypes.string,
  isDisabled: PropTypes.bool,
  isStopAccessBtn: PropTypes.bool,
  isInPageBody: PropTypes.bool,
}

export default PageNavButton
